module.exports = __webpack_public_path__ + "img/relations.92ae6b42.svg";